export const TOP_TLDS_COUNT = 4;
export const TLD_OFFERS_COLUMNS = 4;
export const TLD_OFFERS_PAGE_SIZE = 16;
export const BULK_AVAILABILITY_MAX_DOMAINS = 60;
export const ELIGIBILITY_MAX_BATCHES = 3;
export const CAROUSEL_CHUNK_SIZE = 4;
export const TLD_OFFER_WIDGET_BI_ORIGIN = 'tld_offer_widget';
export const TLD_OFFER_WIDGET_BI_TYPE = 'TLD_STRIP';
export let TldStripComponentName = /*#__PURE__*/function (TldStripComponentName) {
  TldStripComponentName["NONE"] = "no_tld_strip";
  TldStripComponentName["EXPAND"] = "tld_strip_expand";
  TldStripComponentName["CAROUSEL"] = "tld_strip_carousel";
  return TldStripComponentName;
}({});
//# sourceMappingURL=tldOfferWidget.constants.js.map